import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { Button } from '@mellify/ui';
import { ROUTES } from '../../routes/routeConfig';

export const ContentPageActions: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="primary"
        size="sm"
        onClick={() => {
          navigate(ROUTES.DASHBOARD_CONTENT_NEW);
        }}
      >
        <Plus className="w-4 h-4 mr-1.5" />
        Create Post
      </Button>
    </div>
  );
};

ContentPageActions.displayName = 'ContentPageActions';